import { CSInterface } from "csinterface-ts";

const { csInterface }: { csInterface: CSInterface } = window as any;

const getSeparator = () => {
	let sep;
	const OSVersion = csInterface.getOSInformation();
	if (OSVersion.indexOf("Windows") >= 0) {
		sep = '\\\\';
	} else {
		sep = '/';
	}
	return sep;
}

const replaceDividers = (path: string) => {
	const OSVersion = csInterface.getOSInformation();
	if (OSVersion.indexOf("Windows") >= 0) {
		return path.replace(/\//g, '\\');
	}else{
		return path;
	}
}

const getSimpleSeparator = () => {
	let sep;
	const OSVersion = csInterface.getOSInformation();
	if (OSVersion.indexOf("Windows") >= 0) {
		sep = '\\';
	} else {
		sep = '/';
	}
	return sep;
}

export {
	getSeparator,
	getSimpleSeparator,
	replaceDividers
}